import { Component, OnInit } from '@angular/core';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { ActivatedRoute, Router } from '@angular/router';

import { OtherService } from 'src/app/Service/other.service';

import { NotificationService } from 'src/app/Service/notification.service';

import momentJalaali from 'moment-jalaali';

import axios from 'src/app/Service/axios';

interface ITicket {

  iRoute: number;

  strName?: any;

  strCode: string;

  iLength: number;

  strComment?: any;

  strSourceStationName: string;

  strDestinationStationName: string;

  lstRoute_Station: string[];

  lstRoute_Schdeule: string[];

}

@Component({

  selector: 'app-bus-ticket-qrcode',

  templateUrl: './bus-ticket-qrcode.component.html',

  styleUrls: ['./bus-ticket-qrcode.component.css']

})

export class BusTicketQrcodeComponent implements OnInit {

  strStationName: string = '';

  todayDateFull!: String;

  lstRoute: ITicket[] = [];

  constructor(

    private notifyService: NotificationService,

    public otherService: OtherService,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe((params) => {

      this.getStation_Info(params['sc']);

    })

    this.todayDateFull = new Intl.DateTimeFormat('fa-IR', { dateStyle: 'full' }).format(new Date());

  }

  getStation_Info = async (strRouteStationCodes: string | number) => {

    var model = {

      strRouteStationCodes: strRouteStationCodes

    }

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_Station_Info`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (resp.data == null) return this.notifyService.showError('بروز خطا در سامانه');

    if (!res.strStationName) return this.notifyService.showError('اطلاعاتی یافت نشد');

    this.strStationName = res.strStationName;

    this.lstRoute = res.lstRoute;


  }

}
